import { FiChevronRight } from "react-icons/fi";
import { usePatientSelfSchedulingContext } from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";

const PatientSchedulingFooter = () => {
    const { selfSchedule, setRoute, getNextRoute } = usePatientSelfSchedulingContext();

    const handleForward = () => {
        setRoute(getNextRoute());
    };

    const disabled = !selfSchedule?.date || !selfSchedule?.time;

    return (
        <div className="row pt-3 mt-2 mb-3 border-top">
            <div className="col text-right">
                <button
                    className="btn btn-light float-right mr-2"
                    disabled={disabled}
                    onClick={handleForward}
                >
                    Continue <FiChevronRight />
                </button>
            </div>
        </div>
    );
};

export default PatientSchedulingFooter;
